import { createSlice } from '@reduxjs/toolkit';
import { brandId } from '../../types/common';
function makeModel(id, name, provider, modelId, contextWindow, promptPrice, completionPrice) {
    return {
        id: brandId(id),
        name,
        provider,
        modelId,
        contextWindow,
        pricing: { prompt: promptPrice, completion: completionPrice },
        isFavorite: false,
        isCustom: false,
    };
}
const defaultModels = [
    // Anthropic
    makeModel('anthropic-opus-4', 'Claude Opus 4', 'Anthropic', 'anthropic/claude-opus-4', 200000, 15, 75),
    makeModel('anthropic-sonnet-4', 'Claude Sonnet 4', 'Anthropic', 'anthropic/claude-sonnet-4', 200000, 3, 15),
    makeModel('anthropic-haiku-4', 'Claude Haiku 3.5', 'Anthropic', 'anthropic/claude-3.5-haiku', 200000, 0.8, 4),
    // OpenAI
    makeModel('openai-gpt-4o', 'GPT-4o', 'OpenAI', 'openai/gpt-4o', 128000, 2.5, 10),
    makeModel('openai-gpt-4-1', 'GPT-4.1', 'OpenAI', 'openai/gpt-4.1', 1047576, 2, 8),
    makeModel('openai-gpt-4-1-mini', 'GPT-4.1 mini', 'OpenAI', 'openai/gpt-4.1-mini', 1047576, 0.4, 1.6),
    makeModel('openai-gpt-4-1-nano', 'GPT-4.1 nano', 'OpenAI', 'openai/gpt-4.1-nano', 1047576, 0.1, 0.4),
    makeModel('openai-o3', 'o3', 'OpenAI', 'openai/o3', 200000, 10, 40),
    makeModel('openai-o4-mini', 'o4-mini', 'OpenAI', 'openai/o4-mini', 200000, 1.1, 4.4),
    // Google
    makeModel('google-gemini-2-5-pro', 'Gemini 2.5 Pro', 'Google', 'google/gemini-2.5-pro-preview', 1048576, 1.25, 10),
    makeModel('google-gemini-2-5-flash', 'Gemini 2.5 Flash', 'Google', 'google/gemini-2.5-flash-preview', 1048576, 0.15, 0.6),
    // Meta
    makeModel('meta-llama-4-maverick', 'Llama 4 Maverick', 'Meta', 'meta-llama/llama-4-maverick', 1048576, 0.5, 0.7),
    makeModel('meta-llama-4-scout', 'Llama 4 Scout', 'Meta', 'meta-llama/llama-4-scout', 10485760, 0.18, 0.35),
    // DeepSeek
    makeModel('deepseek-v3', 'DeepSeek V3', 'DeepSeek', 'deepseek/deepseek-chat', 131072, 0.27, 1.1),
    makeModel('deepseek-r1', 'DeepSeek R1', 'DeepSeek', 'deepseek/deepseek-reasoner', 131072, 0.55, 2.19),
    // Mistral
    makeModel('mistral-large', 'Mistral Large', 'Mistral', 'mistralai/mistral-large', 131072, 2, 6),
    // Qwen
    makeModel('qwen3-235b', 'Qwen3 235B', 'Qwen', 'qwen/qwen3-235b-a22b', 131072, 0.75, 3),
    makeModel('qwen3-30b', 'Qwen3 30B', 'Qwen', 'qwen/qwen3-30b-a3b', 131072, 0.13, 0.52),
    // Cohere
    makeModel('cohere-command-a', 'Command A', 'Cohere', 'cohere/command-a', 256000, 2.5, 10),
    // xAI
    makeModel('xai-grok-3', 'Grok 3', 'xAI', 'x-ai/grok-3', 131072, 3, 15),
];
function buildInitialState() {
    const entities = {};
    const ids = [];
    for (const model of defaultModels) {
        entities[model.id] = model;
        ids.push(model.id);
    }
    return { entities, ids };
}
const initialState = buildInitialState();
const modelsSlice = createSlice({
    name: 'models',
    initialState,
    reducers: {
        addModel(state, action) {
            const model = action.payload;
            state.entities[model.id] = model;
            if (!state.ids.includes(model.id)) {
                state.ids.push(model.id);
            }
        },
        removeModel(state, action) {
            const id = action.payload;
            delete state.entities[id];
            state.ids = state.ids.filter(mid => mid !== id);
        },
        toggleFavorite(state, action) {
            const model = state.entities[action.payload];
            if (model) {
                model.isFavorite = !model.isFavorite;
            }
        },
        setModels(state, action) {
            state.entities = {};
            state.ids = [];
            for (const model of action.payload) {
                state.entities[model.id] = model;
                state.ids.push(model.id);
            }
        },
    },
});
export const { addModel, removeModel, toggleFavorite, setModels } = modelsSlice.actions;
export default modelsSlice.reducer;
//# sourceMappingURL=modelsSlice.js.map